import { Injectable } from '@angular/core';
import {FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PublicuserModel } from 'src/app/public-user/models/publicuser.model';
import { environment } from '../../environments/environment';
import { catchError, map } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };



@Injectable()
export class PublicuserService {
 // baseUrl: String = 'http://localhost:10325/';
    form: FormGroup = new FormGroup(
        {name: new FormControl('',[Validators.required]),
          email: new FormControl('', [Validators.email, Validators.required]),
          company: new FormControl('',[Validators.required])
        }
      );

constructor(private _http: HttpClient) { }
  initializeFormGroup(){
    this.form.reset()
    this.form.setValue(
      {
        name : '',
        email : '',
        company : ''
      }
    );
    }

    resetFormGroup() {
      this.form.reset();
    }

    addPublicUser(publicuser: PublicuserModel,EngagementId:any,selectedId:any):Observable<any>  {
    {
      publicuser.engagementId=EngagementId;
      publicuser.languageId = selectedId;
      publicuser.createdDate = new Date();
        return this._http.post(environment.APIEndpoint +'api/Publicuser/AddPublicUser', publicuser)
        .pipe(map((data) => data),
        catchError(this.handleError));
     }

     
  }


  getPublicUserList(): any {
    return this._http.get(environment.APIEndpoint + 'api/Publicuser/getPublicUserList')
    .pipe(map((data) => data),
    catchError(this.handleError));
  }

  checkEmail(email:string,engagementId:any){
    return this._http.get(environment.APIEndpoint +'api/Publicuser/CheckEmail?emailId='+email+'&&'+'engagementId='+engagementId,httpOptions)
    .pipe(map((data) => data),
    catchError(this.handleError));
   }

   signUpUser(publicUserId:number):Observable<any> {
    return this._http.get(environment.APIEndpoint +'api/Publicuser/SignUpUser?publicUserId='+publicUserId,httpOptions)
    .pipe(map((data) => data),
                catchError(this.handleError));
  }

   checkNotifications():Observable<any> {
    return this._http.get(environment.APIEndpoint +'api/Publicuser/checkNotifications',httpOptions)
    .pipe(map((data) => data),
    catchError(this.handleError));
   }

   getPublicUserLogs(): any {
    return this._http.get(environment.APIEndpoint + 'api/Publicuser/GetPublicUserLogsList')
      .map((res) => res)
      .catch(this.handleError);
  }


   unsubscribeEngagement(publicUserId:number):Observable<any> {
    return this._http.get(environment.APIEndpoint +'api/Publicuser/unsubscribeEngagement?publicUserId='+publicUserId,httpOptions)
    .pipe(map((data) => data),
    catchError(this.handleError));
   }

   updatePublicUser(imageDetails): any {

    return this._http.post(environment.APIEndpoint + 'api/Publicuser/updatePublicUser', imageDetails)
      .map((res: Response) => res)
      .catch(this.handleError);
  }


   private handleError(error: Response) {
    console.error(error);
    return throwError(error || 'Server error');
}

}
